import { createContext, useContext } from "react";

import type { MarketingVoucherI18nFormModel } from "../../model/type";

type QueryData = MarketingVoucherI18nFormModel["QueryData"];
type ViewModel = MarketingVoucherI18nFormModel["ViewModel"];

export type MarketingVoucherI18nFormModelContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;
};

export const MarketingVoucherI18nFormModelContext = createContext<MarketingVoucherI18nFormModelContextType | null>(
	null,
);

export const useMarketingVoucherI18nFormModelContext = () => {
	const context = useContext(MarketingVoucherI18nFormModelContext);

	if (!context) {
		throw new Error(
			"useMarketingVoucherI18nFormModelContext must be used within a MarketingVoucherI18nFormModelContext.Provider",
		);
	}

	return context;
};
